import { ActionTree } from 'vuex';
// eslint-disable-next-line import/no-cycle
import rootStore from '@/store';
import { RootState } from '@/store/types';
import SystemFieldsExcluder from '@/classes/graphql-introspection/PimcoreSystemFieldsExcluder';
import GraphQLFieldsExtractor from '@/classes/graphql-introspection/GraphQLFieldsExtractor';
import EntitySchemaConstructor from '@/classes/schema-constructors/EntitySchemaConstructor';
import gql from 'graphql-tag';
import { defaultApolloClient } from '@/vue-apollo';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';
import { getModule } from 'vuex-module-decorators';
import GraphQLIntrospectionModule from '@/store/graphql-introspection';
import mutations from './mutations';
import { DirectoryState } from './types';

const actions: ActionTree<DirectoryState, RootState> = {
  async fetchDirectory({ commit, rootState }, { commitName, pimCoreClassName }): Promise<any> {
    const mutationsKey = Object.keys(mutations);
    if (!mutationsKey.includes(commitName)) {
      console.error(`commitName: ${commitName} not found`);
      return null;
    }

    if (mutationsKey.includes(`${commitName}IsLoading`)) {
      commit(`${commitName}IsLoading`, true);
    }

    let data = [];

    try {
      const fieldsExcluder = new SystemFieldsExcluder();
      const fieldsExtractor = new GraphQLFieldsExtractor(fieldsExcluder);
      const graphQLIntrospectionModule = getModule(GraphQLIntrospectionModule, rootStore);
      if (!rootState?.graphQLIntrospection?.introspectionQuery) {
        await graphQLIntrospectionModule.getPimcoreIntrospection(pimCoreClassName);
      }
      const coordinatorIntrospection = new PimcoreEntityIntrospection(
        rootState?.graphQLIntrospection?.introspectionQuery!,
        pimCoreClassName,
        fieldsExtractor,
      );
      const coordinatorSchemaConstructor = new EntitySchemaConstructor(coordinatorIntrospection!, fieldsExtractor);
      const listingSchema = coordinatorSchemaConstructor.constructListingSchema();

      const resp = await defaultApolloClient.query({ query: gql`${listingSchema}`, variables: {}, fetchPolicy: 'network-only' });
      data = resp.data?.[`get${pimCoreClassName}Listing`]?.items?.map(
        ({ node }: any) => node
      );
    } catch (e) {
      console.error(e);
    }

    commit(commitName, data);
    if (mutationsKey.includes(`${commitName}IsLoading`)) {
      commit(`${commitName}IsLoading`, false);
    }
    return data;
  },
};

export default actions;
